import { api } from "services/api.service";
import { defaultLocationManagementLocation } from "types/locationManagement/location";
import { withActionErrorAlert } from "utils/withActionError";
import { withAuth } from "routes/utils/withAuth";
import { useGlobalAlert } from "hooks/useAlert";

export const loader = withAuth(async () => {
  return { location: defaultLocationManagementLocation };
});

export async function action({ request }: { request: Request }) {
  const formData = await request.formData();
  const res = await withActionErrorAlert(() =>
    api.request({
      method: "POST",
      url: `/location_management/locations`,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    }),
  );
  if (res?.status === 201) {
    useGlobalAlert.alertSuccess("The location was created successfully.");
    return { created: true };
  }
  return res;
}
